<template>
  <div v-if="crear || persona.id">
    <h4 v-if="! crear" class="mb-3">{{ persona.nombre }} {{ persona.apellidos }}</h4>

    <div class="card mb-3" v-if="! crear">
      <h5 class="card-header bg-secondary text-white">Eliminar persona</h5>
      <div class="card-body">
        <template v-if="persona.rol == 'titular'">
        <p>No es posible eliminar al socio titular.</p>
        </template>
        <template v-else>
        <p>Pulsa este botón para borrar de nuestra base de datos a {{ persona.nombre }} {{ persona.apellidos }}</p>
        <p class="text-center mb-0"><button type="button" class="btn btn-primary" @click="eliminarPersona()">Eliminar persona</button></p>
        </template>
      </div>
    </div>

    <form class="form-horizontal" id="form-persona" action="" @submit.stop.prevent="enviarPersona" novalidate>

    <div class="card">
      <h5 v-if="crear == 'adulto'" class="card-header bg-secondary text-white">Añadir nuevo adulto</h5>
      <h5 v-else-if="crear == 'menor'" class="card-header bg-secondary text-white">Añadir nuevo menor</h5>
      <h5 v-else class="card-header bg-secondary text-white">Editar datos de persona</h5>
      <div class="card-body">
        <fieldset>

        <div v-if="persona.tipo == 'adulto'" class="form-group row">
          <label class="col-md-2 col-form-label" for="rol">Rol</label>  
          <div v-if="persona.rol == 'titular'" class="col-md-5">
            <input id="rol" name="rol" type="text" v-model="persona.rol" class="form-control" readonly>
          </div>
          <div v-else class="col-md-5">
            <select class="select form-control" name="rol" v-model="persona.rol" :class="validarCampo(persona.rol)" required>
              <option v-for="r in roles" :key="r" :value="r">{{ r }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar el rol del nuevo adulto</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="nombre">Nombre</label>  
          <div class="col-md-5">
            <input id="nombre" name="nombre" type="text" v-model="persona.nombre" class="form-control" :class="validarCampo(persona.nombre)" required>
            <div class="invalid-feedback">Debes introducir un nombre</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="apellidos">Apellidos</label>  
          <div class="col-md-5">
            <input id="apellidos" name="apellidos" type="text" v-model="persona.apellidos" class="form-control" :class="validarCampo(persona.apellidos)" required>
            <div class="invalid-feedback">Debes introducir al menos un apellido</div>
          </div>
        </div>

        <div v-if="this.persona.tipo == 'adulto'" class="form-group row">
          <label class="col-md-2 col-form-label" for="relacion">Relación</label>
          <div class="col-md-5">
            <select class="select form-control" name="relacion" v-model="persona.relacion" :class="validarCampo(persona.relacion)" required>
              <option v-for="r in relaciones" :key="r" :value="r">{{ r }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar la relación</div>
          </div>
        </div>

        <div v-if="persona.tipo == 'menor'" class="form-group row">
          <label class="col-md-2 col-form-label" for="nivel">Curso</label>
          <div class="col-md-5">
            <select class="select form-control" name="nivel" v-model="persona.nivel.id" :class="validarCampo(persona.nivel.id)" required>
              <option v-for="n in nivelesPersona()" :key="n.id_nivel" :value="n.id_nivel">{{ n.nombre }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar el curso del menor</div>
          </div>
        </div>

        <div v-if="persona.tipo == 'menor'" class="form-group row">
          <label class="col-md-2 col-form-label" for="clase">Clase</label>
          <div class="col-md-5">
          <select class="select form-control" name="clase" v-model="persona.nivel.clase">
            <option v-for="c in clases" :key="c" :value="c">{{ c }}</option>
          </select>
          </div>
        </div>

        <div v-if="persona.tipo == 'adulto'" class="form-group row">
          <label class="col-md-2 col-form-label" for="nif">NIF</label>  
          <div class="col-md-5">
            <input id="nif" name="nif" type="text" v-model="persona.nif" class="form-control" :class="validarCampo(validarNIF(persona.nif))" required>
            <div class="invalid-feedback">Debes indicar un NIF o NIE válido</div>
          </div>
        </div>

        <div v-if="persona.tipo == 'menor'" class="form-group row">
          <label class="col-md-2 col-form-label" for="nacimiento">Fecha de nacimiento</label>  
          <div class="col-md-5">
            <input id="nacimiento" name="nacimiento" type="text" v-model="persona.nacimiento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" class="form-control" :class="validarCampo(validarFecha(persona.nacimiento))" required>
            <div class="invalid-feedback">Debes indicar una fecha en formato dd/mm/aaaa</div>
          </div>
        </div>

        <div v-if="persona.tipo == 'adulto'" class="form-group row">
          <label class="col-md-2 col-form-label" for="email">Email</label>  
          <div class="col-md-5">
            <input id="email" name="email" type="text" v-model="persona.email" class="form-control" :class="validarCampo(validarEmail(persona.email))" required>
            <div class="invalid-feedback">Debes indicar un email válido</div>
          </div>
        </div>

        <div v-if="persona.tipo == 'adulto'" class="form-group row">
          <label class="col-md-2 col-form-label" for="domicilio">Domicilio</label>  
          <div class="col-md-5">
            <input id="domicilio" name="domicilio" type="text" v-model="persona.domicilio" class="form-control">
          </div>
        </div>

        <div v-if="persona.tipo == 'adulto'" class="form-group row">
          <label class="col-md-2 col-form-label" for="telefono1">Teléfono 1</label>  
          <div class="col-md-5">
            <input id="telefono1" name="telefono1" type="text" v-model="persona.telefono1" class="form-control" :class="validarCampo(validarTelefono(persona.telefono1))" required>
            <div class="invalid-feedback">Debes indicar al menos un teléfono válido</div>
          </div>
        </div>

        <div v-if="persona.tipo == 'adulto'" class="form-group row">
          <label class="col-md-2 col-form-label" for="telefono2">Teléfono 2</label>  
          <div class="col-md-5">
            <input id="telefono2" name="telefono2" type="text" v-model="persona.telefono2" class="form-control">
          </div>
        </div>

<!--
<div class="form-group row">
  <label class="col-md-2 col-form-label" for="permiso-comunicacion">Comunicación</label>  
  <div class="col-md-5">
  <div class="form-check">
{% if persona.permiso_comunicacion == 1 %}
  <input id="permiso-comunicacion" name="permiso-comunicacion" type="checkbox" class="form-check-input" checked>
{% else %}
  <input id="permiso-comunicacion" name="permiso-comunicacion" type="checkbox" class="form-check-input">
{% endif %}
  <label class="form-check-label" for="permiso-comunicacion">Permiso para recibir comunicaciones del AMPA sobre eventos, actividades y novedades de la asociación.</label>
  </div>
  </div>
</div>
{% endif %}
-->

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="observaciones">Observaciones</label>  
          <div class="col-md-5">
          <textarea id="observaciones" name="observaciones" class="form-control" rows="3" v-model="persona.observaciones"></textarea>
          </div>
        </div>

        </fieldset>

        <button type="submit" class="btn btn-primary">Guardar</button>

      </div>
    </div>
    </form>
  </div>
</template>

<script>

import { api } from '../api/api.js';
import { obtenerNiveles } from '../curso.js';
import { validarNIF, validarEmail, validarFecha, validarTelefono } from '../validacion.js';

export default {
	name: 'SociosPersonaEditar',
	props: [ 'admin', 'crear', 'id_familia', 'id_persona' ],
	data () {
		return {
			validado: false,
			persona: {
				id: null,
				id_familia: null,
				tipo: null,
				rol: null,
				nombre: null,
				apellidos: null,
				nif: null,
				nacimiento: null,
				nivel: {
					id: null,
					nombre: null,
					clase: null,
				},
				domicilio: null,
				email: null,
				telefono1: null,
				telefono2: null,
				observaciones: null,
			},
			clases: ['A', 'B'],
			relaciones: ['padre', 'madre', 'tutor', 'abuelo', 'abuela', 'otro'],
			roles: ['autorizado', 'contacto'],
		}
	},
	created () {
		if (this.crear) {
			if (this.admin) {
				this.persona.id_familia = this.id_familia;
			} else {
				this.persona.id_familia = this.$parent.sesion.id_familia;
			}
		}
		if (this.crear == 'adulto') {
			this.persona.tipo = 'adulto';
		} else if (this.crear == 'menor') {
			this.persona.tipo = 'menor';
		} else {
			this.obtenerPersona();
		}
	},
	methods: {
		validarNIF,
		validarEmail,
		validarFecha,
		validarTelefono,
		validarCampo(condicion) {
			if (! this.validado) {
				return '';
			}
			if (condicion) {
				return 'is-valid';
			} else {
				return 'is-invalid';
			}
		},
		obtenerPersona() {
			api(`/personas/${this.id_persona}`)
				.then((data) => {
					this.persona = data.resultado;

					// TODO: quitar esto tras unificarlo en el backend
					if (this.persona.rol == 'titular' || this.persona.rol == 'contacto' || this.persona.rol == 'autorizado') {
						this.persona.tipo = 'adulto';
					}
					if (this.persona.rol == 'beneficiario') {
						this.persona.tipo = 'menor';
					}
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		enviarPersona(e) {
			if (this.persona.tipo == 'adulto') {
				if (! validarNIF(this.persona.nif) ||
						! validarEmail(this.persona.email) ||
						! validarTelefono(this.persona.telefono1) ||
						! e.target.checkValidity()) {
					this.validado = true;
					return;
				}
			} else {
				if (! validarFecha(this.persona.nacimiento) || ! e.target.checkValidity()) {
					this.validado = true;
					return;
				}
			}
			this.validado = false;

			if (this.crear) {
				api(`/personas`, 'POST', this.persona)
					.then((data) => {
						if (data.resultado) {
							this.volverVistaFamilia();
						} else {
							// TODO: mostrar un error
						}
					});
			} else {
				api(`/personas/${this.persona.id}`, 'PUT', this.persona)
					.then((data) => {
						if (data.resultado) {
							this.volverVistaFamilia();
						} else {
							// TODO: mostrar un error
						}
					});
			}
		},
		eliminarPersona() {
			api(`/personas/${this.persona.id}`, 'DELETE')
				.then((data) => {
					if (data.resultado) {
						this.volverVistaFamilia();
					} else {
						// TODO: mostrar un error
					}
				});
		},
		volverVistaFamilia() {
			if (this.admin) {
				this.$router.push(`/admin/familia/${this.persona.id_familia}`);
			} else {
				this.$router.push('/');
			}
		},
		nivelesPersona() {
			const niveles = [];
			const nivelesTodos = obtenerNiveles();
			for (const n of nivelesTodos) {
				// No debería llamarse para adultos
				if (this.persona.tipo == 'adulto' && n.seccion == 'adultos') {
					niveles.push(n);
				}
				if (this.persona.tipo == 'menor' && (n.seccion == 'alumnos' || n.seccion == 'exalumnos')) {
					niveles.push(n);
				}
			}
			return niveles;
		}
	}
}
</script>
